var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#827127",
    fillRule: "evenodd",
    d: "M6.633 0c3.663 0 6.634 2.947 6.634 6.583a6.5 6.5 0 0 1-1.222 3.807L17 15.305l-.691.695-4.894-4.854a6.64 6.64 0 0 1-4.782 2.02C2.971 13.166 0 10.219 0 6.583S2.97 0 6.633 0m0 .98C3.511.98.981 3.488.981 6.582s2.53 5.604 5.652 5.604 5.653-2.51 5.653-5.604S9.756.978 6.633.978z"
  })));
};
export default SvgSearchIcon;